import customAxios from "../../customAxios";

import {CREATE_PARENT} from "../../routes";
import {ICreateAndUpdateParent} from "./../../../types/parent.interface";

const createParent = async (formData: ICreateAndUpdateParent) => {
  try {
    return (
      await customAxios.post(CREATE_PARENT, {
        ...formData,
        gender: formData.gender?.value,
      })
    ).data;
  } catch (error: unknown) {
    console.error({CREATE_PARENT: error});
    return false;
  }
};

export default createParent;
